import erroricon from "../../../assets/images/icons/warrning.svg"

const ErrorMessage = ({error}) => {
  
  return (
    <div className="text-center mt-5">
  <img src={erroricon} height="250px" />
  <h2 className="mt-3">{error.response.data.message }</h2>
 </div>
  )
}

export default ErrorMessage